import { useState, useEffect } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'

import { Tabs, Card, Flex } from '@percent/lemonade'
import { TabPanel } from '@percent/admin-dashboard/common/components'
import { ACCOUNT_TAB_ROUTES, type AccountTabRoute, useAccountTabs } from './hooks/useAccountTabs'
import { Members } from './components/members'
import { Groups } from './components/groups'
import { Roles } from './components/roles'
import { ServiceList } from './components/services'

const panels: Record<AccountTabRoute, JSX.Element> = {
  [ACCOUNT_TAB_ROUTES.members]: <Members />,
  [ACCOUNT_TAB_ROUTES.groups]: <Groups />,
  [ACCOUNT_TAB_ROUTES.roles]: <Roles />,
  [ACCOUNT_TAB_ROUTES.services]: <ServiceList />
}

export function AccountListContainer() {
  const location = useLocation()
  const navigate = useNavigate()
  const { tabs, defaultRoute, isRouteClosed } = useAccountTabs()
  const [value, setValue] = useState(location.pathname)
  const isClosed = location.pathname === '/accounts' || isRouteClosed(location.pathname)

  useEffect(() => {
    if (isClosed) {
      navigate(defaultRoute, { replace: true })
    } else {
      setValue(location.pathname)
    }
  }, [location.pathname, navigate, isClosed, defaultRoute])

  const handleChange = (newValue: string) => {
    setValue(newValue)
    navigate(newValue)
  }

  return (
    <Card>
      <Flex direction="column" w="100%">
        <Flex direction="column" px="lg" pt="lg">
          <Tabs
            activeTab={value}
            onChangeTab={handleChange}
            items={tabs.map(({ route, label }) => ({ key: route, label }))}
          />
        </Flex>
        {tabs.map(({ route }) => (
          <TabPanel key={route} value={value} index={route}>
            {panels[route]}
          </TabPanel>
        ))}
      </Flex>
    </Card>
  )
}
